function adjustImageBanners() {
  /** adjust top image banner height if it comes after header */
  const headerElement = getHeaderElement();
  const topImageBanner =
    headerElement.nextElementSibling.getElementsByClassName(
      "image-banner"
    )[0] ?? null;

  if (topImageBanner !== null) {
    topImageBanner.style.height = `calc(100vh - ${headerElement.clientHeight}px)`;
  }
}

adjustImageBanners();
